import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["location"]

import { onMounted, onUnmounted, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
  name: { type: String, default: "tooltip" },
  screenPadding: { type: Number, default: 16 },
  location: { type: String },
},
  setup(__props) {

const props = __props;
const tooltipComponentRef = ref();
const placeholder = ref();
const dropdown = ref();
const tooltipOpen = ref();
const dropdownContent = ref();

function handleDropdownPosition() {
  const screenPadding = 16;
  const placeholderRect = placeholder.value?.getBoundingClientRect();
  const windowWidth = window.innerWidth;
  const availableWidth = windowWidth - placeholderRect.x - placeholderRect.width - screenPadding;

  if (props.location !== "left") {
    tooltipComponentRef.value.style.minWidth = `${availableWidth - 16}px`;
    tooltipComponentRef.value.style.maxWidth = "300px";
  }
}
function handleMousover() {
  if (window.innerWidth > 576) {
    toggle();
  }
}

function handleMouseout() {
  if (window.innerWidth > 576) {
    close();
  }
}

function handleClick() {
  if (window.innerWidth <= 576) {
    toggle();
  }
}

function toggle() {
  if (tooltipOpen.value === true) {
    close();
  } else {
    open();
  }
}

function open() {
  handleDropdownPosition();
  tooltipOpen.value = true;
}

function close() {
  tooltipOpen.value = false;
}

function handleClickOutside(event: any) {
  if (!(tooltipComponentRef.value as HTMLElement).contains(event.target)) {
    tooltipOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});
onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    ref_key: "tooltipComponentRef",
    ref: tooltipComponentRef,
    class: ["tooltip-component", { open: tooltipOpen.value }]
  }, _ctx.$attrs), [
    _createElementVNode("div", {
      class: "tooltip-component__label",
      "aria-describedby": "tooltip-demo-content",
      "data-tooltip-placeholder": "",
      ref_key: "placeholder",
      ref: placeholder,
      onMouseover: _withModifiers(handleMousover, ["prevent"]),
      onMouseout: handleMouseout,
      "on:touchStart": toggle,
      onClick: _withModifiers(handleClick, ["stop"])
    }, [
      _renderSlot(_ctx.$slots, "toggle")
    ], 544),
    _createElementVNode("div", {
      class: "tooltip-component-dropdown",
      "data-tooltip-dropdown": "",
      ref_key: "dropdown",
      ref: dropdown
    }, [
      _createElementVNode("div", {
        ref_key: "dropdownContent",
        ref: dropdownContent,
        role: "tooltip",
        id: "tooltip-demo-content",
        class: "tooltip-component-dropdown__content",
        location: __props.location
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, _hoisted_1)
    ], 512)
  ], 16))
}
}

})